module.exports = __webpack_public_path__ + "static/media/chat.7a605174.svg";